import React from 'react';
import { Info } from 'lucide-react';

interface MetricCardProps {
  title: string;
  value: string | number;
  sub: string;
  icon: React.ElementType;
  isDark: boolean;
  color?: string;
  description?: string;
}

const MetricCard: React.FC<MetricCardProps> = ({ title, value, sub, icon: Icon, isDark, color = "blue", description }) => {
  const colors: Record<string, string> = {
    blue: isDark ? 'bg-blue-900/20 text-blue-400' : 'bg-blue-50 text-blue-700',
    orange: isDark ? 'bg-orange-900/20 text-orange-400' : 'bg-orange-50 text-orange-700',
    green: isDark ? 'bg-emerald-900/20 text-emerald-400' : 'bg-emerald-50 text-emerald-700',
    purple: isDark ? 'bg-purple-900/20 text-purple-400' : 'bg-purple-50 text-purple-700',
    red: isDark ? 'bg-red-900/20 text-red-400' : 'bg-red-50 text-red-700',
    yellow: isDark ? 'bg-yellow-900/20 text-yellow-400' : 'bg-yellow-50 text-yellow-700'
  };
  return (
    <div className={`relative group p-6 rounded-xl border transition-all ${isDark ? 'bg-[var(--surface)] border-[var(--border)]' : 'bg-white border-[var(--border)] shadow-sm'}`}>
      <div className="flex justify-between items-center mb-4">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <p className={`text-xs font-bold uppercase tracking-wider ${'text-[var(--text-secondary)]'}`}>{title}</p>
            {description && (
              <div className="relative group/info">
                <Info size={14} className="text-[var(--text-secondary)] cursor-help hover:text-blue-400 transition-colors" />
                <div className={`absolute left-0 bottom-full mb-2 w-64 p-3 rounded-lg shadow-xl text-sm leading-relaxed z-50 invisible group-hover/info:visible ${isDark ? 'bg-[#0f172a] border border-[var(--border)] text-gray-200' : 'bg-white border border-[var(--border)] text-gray-700'}`}>
                  {description}
                </div>
              </div>
            )}
          </div>
          <h3 className={`text-2xl font-extrabold ${'text-[var(--text-primary)]'}`}>{value}</h3>
        </div>
        <div className={`p-3 rounded-lg ${colors[color] || colors.blue}`}>
          <Icon size={24} />
        </div>
      </div>
      <p className={`text-xs ${isDark ? 'text-[var(--text-tertiary)]' : 'text-[var(--text-secondary)]'}`}>{sub}</p>
    </div>
  );
};

export default MetricCard;
